export default function (context) {
	context.store.dispatch('updateFooterStyle', 'short')
}
